import React, { useState, useEffect } from "react";
import "./App.css";
import { ThemeProvider } from "@emorg-prd/react-standard";
import UserService from "./api/User";
import Header from "./components/header";
import Footer from "./components/footer";
import AppRoutes from "./routing";

import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { apiRequest } from "./authConfig";
import LoaderIcon from "./components/loaderIcon";

function App() {
  const { instance, accounts, inProgress } = useMsal();
  const [isAuthorized, setIsAuthorized] = useState(null);

  useEffect(() => {
    const account = instance.getActiveAccount() || accounts[0];

    if (!account && inProgress === InteractionStatus.None) {
      instance.loginRedirect({ scopes: apiRequest.scopes });
    }
  }, [instance, accounts, inProgress]);

  useEffect(() => {
    const account = instance.getActiveAccount() || accounts[0];
    if (!account || inProgress !== InteractionStatus.None) return;

    const cacheKey = `isAuthorized:${account.homeAccountId}`;
    const raw = window.sessionStorage.getItem(cacheKey);

    if (raw !== null) {
      setIsAuthorized(JSON.parse(raw));
      return;
    }

    (async () => {
      try {
        const res = await UserService.getUserGroups();
        const flag = !!res?.isAdmin;
        setIsAuthorized(flag);
        window.sessionStorage.setItem(cacheKey, JSON.stringify(flag));
      } catch (err) {
        console.error("Failed obtaining groups/authorizations:", err);
        setIsAuthorized(false);
      }
    })();
  }, [accounts, inProgress]);

  return (
    <ThemeProvider>
      <div className='app-container'>
        <Header />
        {isAuthorized === null ? (
          <LoaderIcon />
        ) : (
          <AppRoutes isAuthorized={isAuthorized} />
        )}
      </div>
      <Footer />
    </ThemeProvider>
  );
}

export default App;